import { createTheme } from "@material-ui/core";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import { muiBreakpoints } from "./breakpoints";

const breakpoints = createBreakpoints({ values: muiBreakpoints });

export const muiTheme = createTheme({
  typography: {
    fontFamily: "'Lato', sans-serif",
  },
  palette: {
    text: {
      primary: "#333333",
    },
  },
  overrides: {
    MuiTouchRipple: {
      root: {
        display: "none",
      },
    },
    MuiFormControl: {
      root: {
        marginTop: 20,
        paddingBottom: 20,
        [breakpoints.up("xs")]: {
          paddingBottom: 24,
        },
      },
    },
    MuiTextField: {
      root: {
        "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
          color: "#333",
        },
      },
    },
    MuiFormLabel: {
      root: {
        color: "#999999",
        fontFamily: "var(--heading-font)",
        fontSize: 16,
        fontWeight: 500,
        "&.Mui-disabled": {
          color: "rgb(198, 198, 198)",
        },
      },
    },
    MuiSelect: {
      outlined: {
        padding: 10,
        "&.MuiSelect-outlined": {
          paddingRight: 40,
        },
      },
    },
    MuiInputBase: {
      input: {
        fontFamily: "var(--heading-font)",
        fontSize: 16,
        fontWeight: 500,
        "&:-webkit-autofill": {
          "-webkit-box-shadow": "0 0 0px 1000px transparent inset",
        },
      },
      root: {
        minHeight: 40,
        fontFamily: "var(--heading-font)",
        fontSize: 16,
        fontWeight: 500,
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 2,
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderWidth: 1,
        },
        "&.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgb(92, 92, 92)",
          borderWidth: 1,
        },
        "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgb(198, 198, 198)",
        },
      },
      input: {
        padding: "14.5px 16px",
      },
      notchedOutline: {
        transition: ".3s ease border-color",
        fontSize: 12,
        borderColor: "#999999",
        color: "rgb(75, 75, 75)",
        top: 0,
        "& > legend": {
          display: "none",
        },
      },
      adornedEnd: {
        paddingRight: 0,
      },
    },
    MuiInputLabel: {
      outlined: {
        "&.MuiInputLabel-root": {
          transform: "translate(16px, 16px) scale(1)",
        },
        "&.MuiInputLabel-marginDense": {
          transform: "translate(16px, 12px) scale(1)",
        },
        "&.MuiInputLabel-shrink": {
          transform: "translate(16px, -16px) scale(0.75)",
        },
      },
    },
    MuiMenuItem: {
      root: {
        fontFamily: "var(--heading-font)",
        fontSize: 14,
      },
    },
    MuiFormHelperText: {
      root: {
        fontFamily: "var(--heading-font)",
        fontSize: 10,
        fontWeight: 500,
      },
      contained: {
        marginLeft: 0,
        marginRight: 0,
      },
    },
    MuiCheckbox: {
      root: {
        color: "rgb(151, 151, 151)",
      },
    },
    MuiButtonBase: {
      root: {
        fontFamily: "var(--heading-font)",
      },
    },
    MuiContainer: {
      root: {
        [breakpoints.up("lg")]: {
          paddingRight: 30,
          paddingLeft: 30,
        },
      },
    },
  },
  breakpoints,
});
